/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { LineChartIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/enterprise-admin-home';

const styles = {
  container: css`
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-radius: var(--cds-spacing-100);
    flex: 1 1 100%;
    display: flex;
    padding: var(--cds-spacing-200);
    margin: var(--cds-spacing-100) 0;
  `,
  message: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: var(--cds-spacing-200);
  `,
  icon: css`
    height: 48px;
    width: 48px;
    background: var(--cds-color-emphasis-primary-background-xweak);
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

const EmptyTrackedSkillsMessage: React.FC = () => {
  return (
    <div css={styles.container}>
      <div css={styles.message}>
        <Typography2 variant="subtitleMedium" component="span">
          {_t('No tracked skills have been added')}
        </Typography2>
        <div css={styles.icon}>
          <LineChartIcon size="large" color="interactive" />
        </div>
        <Typography2 component="span">{_t('Begin by adding skills in Skills Tracking')}</Typography2>
      </div>
    </div>
  );
};

export default EmptyTrackedSkillsMessage;
